import React from 'react';
import $ from 'jquery';
import { DISPATCH_ID, json, CURRENCY } from '../libs/utils/Const';
import { connect } from 'react-redux';
import { Page, Text, Image, Document, StyleSheet, PDFViewer, Font, View, pdf } from '@react-pdf/renderer';
import moment from "moment";
import { ApiClient } from '../libs/apiClient';
import ReportTitle from '../components/reports/ReportTitle';
import ReportNum from '../components/reports/ReportNum';
import BillTo from '../components/reports/BillTo';
import ThankYouMsg from '../components/reports/ThankYouMsg';
import ItemsTable from '../components/reports/ItemsTable';
import ItemsTablePaymets from '../components/reports/ItemsTablePaymets';
import SendMailPDF from '../components/SendMailPDF';
import ItemsTableMerchandise from '../components/reports/ItemsTableMerchandise';
import StockTransferLines from '../components/reports/StockTransfer';
import { CardTransactionsTitle, CardTransactionsTable } from './CardTransacctionsPrint';
import ReportTitleOC from '../components/reports/ReportTitleOC';
import FooterOC from './reports/FooterOC';
let apiClient = ApiClient.getInstance();
const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 15,
        paddingLeft: 30,
        paddingRight: 25,
        paddingBottom: 30,
        lineHeight: 1.5,
        flexDirection: 'column',
    },

    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,

    },
    title: {
        position: 'absolute'
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 8,
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },
});

const DocumentsToPrint = (props) => {
    return (
        <Document>
            {props.data ?
                props.data.map((document, index) => {
                    let header = document.headerDocument;
                    let items = document.itemsDocument;
                    let paymentItems = document.items;
                    let checks = document.checks;
                    let cards = document.creditCards;

                    return (
                        <>
                            {props.format === 1 &&
                                <Page size="A4" orientation='portrait' style={[styles.page]} key={index}>
                                    <View fixed>
                                        {props.view !== 'PointsCard' ? <ReportTitle style={styles.title} header={header} view={props.view} _user={props._user} items={items} />
                                            : <CardTransactionsTitle style={styles.title} header={header} view={props.view} _user={props._user} />
                                        }
                                    </View>

                                    {props.view === "payment" || props.view === "outgoingPayment" ?
                                        <ItemsTablePaymets items={items} header={header} checks={checks} cards={cards} view={props.view} />
                                        : (props.view === "transfers" || props.view === "transfersEntry" || props.view === "transfersOutput") ?
                                            <ItemsTableMerchandise items={items} header={header} view={props.view} />
                                            : props.view === "transfersRequest" ?
                                                <StockTransferLines items={items} header={header} view={props.view} />
                                                : props.view === "PointsCard" ?
                                                    <CardTransactionsTable transactions={items} header={header} view={props.view} />
                                                    :
                                                    <ItemsTable items={items} header={header} view={props.view} />
                                    }
                                    <ThankYouMsg header={header} _user={props._user} view={props.view} />
                                    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                                        `${pageNumber} / ${totalPages}`
                                    )} fixed />

                                    {/* <ReportNum header = {header} /> */}
                                    {/* <BillTo header = {header} title='Orden de Venta'/> */}
                                </Page>}


                            {props.format === 2 &&
                                <Page size="A4" orientation='portrait' style={[styles.page]} key={index}>
                                    <View fixed>
                                        <ReportTitleOC style={styles.title} header={header} view={props.view} _user={props._user} items={items} />
                                    </View>
                                    <ItemsTable items={items} header={header} view={props.view} format={props.format} />

                                    <FooterOC header={header} _user={props._user} view={props.view} />
                                    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                                        `${pageNumber} / ${totalPages}`
                                    )} fixed />
                                </Page>}
                        </>
                    )
                })
                : ""}
        </Document>
    );
}






class PrintToDocumentsModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showSendMailModal: false,
            isGeneratingPDF: false,
            pdfBase64: null,
            pdfBlobUrl: null,
            isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 1300,
            mailTools: {
                sendMailModel: {
                    to: '',
                    cc: '',
                    subject: '',
                    message: '',
                    docEntry: null,
                    sendFile: true,
                    pdfData: null
                },
                RefreshSendMailModel: this.refreshSendMailModel
            }
        }
    }

    componentDidMount() {
        this.generateAndStorePDF();
    }

    componentWillUnmount() {
        if (this.state.pdfBlobUrl) {
            URL.revokeObjectURL(this.state.pdfBlobUrl);
        }
    }

    generateAndStorePDF = async () => {
        const { data, view, _user, format } = this.props;

        try {
            this.setState({ isGeneratingPDF: true });

            const pdfDoc = <DocumentsToPrint data={data} view={view} _user={_user} format={format} />;
            const pdfBlob = await pdf(pdfDoc).toBlob();

            const blobUrl = URL.createObjectURL(pdfBlob);
            this.setState({ pdfBlobUrl: blobUrl });

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64 = reader.result.split(',')[1];
                    this.setState({ pdfBase64: base64 });
                    resolve(base64);
                };
                reader.onerror = reject;
                reader.readAsDataURL(pdfBlob);
            });
        } catch (error) {
            console.error('Error generating PDF:', error);
        } finally {
            this.setState({ isGeneratingPDF: false });
        }
    }
    
    downloadPDF = () => {
        const { pdfBlobUrl } = this.state;
        if (!pdfBlobUrl) return;
        window.open(pdfBlobUrl, '_blank');
    }

    closeConfirm = async () => {
        const { setPrintToDocumentsModal } = this.props;
        $('#printToDocumentsModal').modal('hide');
        await setPrintToDocumentsModal(false);
    }

    refreshSendMailModel = (model) => {
        this.setState({
            mailTools: {
                ...this.state.mailTools,
                sendMailModel: model
            }
        });
    }

    openSendMailModal = () => {
        $('#printToDocumentsModal').modal('hide');

        setTimeout(() => {
            $('#sendMailPDF').modal('show');
            this.setState({ showSendMailModal: true });
        }, 300);
    }

    closeSendMailModal = () => {
        $('#sendMailPDF').modal('hide');
        this.setState({ showSendMailModal: false });
    }

    sendEmailWithPDF = async () => {
        const { mailTools, pdfBase64 } = this.state;
        const { data, notificationReducer: { showAlert } } = this.props;

        try {

            if (!pdfBase64) {
                showAlert({ type: 'error', message: 'Error: PDF no disponible', timeOut: 5000 });
                return;
            }

            if (!mailTools.sendMailModel.to) {
                showAlert({ type: 'error', message: 'Por favor ingrese un correo destinatario', timeOut: 5000 });
                return;
            }

            if (!mailTools.sendMailModel.subject) {
                showAlert({ type: 'error', message: 'Por favor ingrese un asunto', timeOut: 5000 });
                return;
            }

            this.setState({ isGeneratingPDF: true });

            const docEntry = data[0]?.headerDocument?.DocEntry || 'document';

            const now = new Date();
            const datePart =
                now.getFullYear().toString() +
                String(now.getMonth() + 1).padStart(2, '0') +
                String(now.getDate()).padStart(2, '0');

            const fileName = `Documento_${docEntry}_${datePart}.pdf`;

            const emailData = {
                to: mailTools.sendMailModel.to,
                cc: mailTools.sendMailModel.cc,
                subject: mailTools.sendMailModel.subject,
                message: mailTools.sendMailModel.message,
                docEntry: docEntry,
                pdfBase64: pdfBase64,
                fileName: fileName,
                header: data[0]?.headerDocument || {}
            };

            const response = await apiClient.sendEmailWithPDF(emailData);

            if (response && response.status === 1) {
                showAlert({ type: 'success', message: 'Correo enviado exitosamente', timeOut: 5000 });
                this.closeSendMailModal();
            } else {
                showAlert({ type: 'error', message: 'Error al enviar correo', timeOut: 5000 });
                return;
            }

        } catch (error) {
            showAlert({ type: 'error', message: 'Error al enviar correo: ', timeOut: 5000 });
        } finally {
            this.setState({ isGeneratingPDF: false });
        }
    }

    render() {
        const { data, view, _user, format } = this.props;
        const { mailTools, isGeneratingPDF, isMobile, pdfBlobUrl } = this.state;
        return (
            <>
                <div className="modal" tabIndex="-1" role="dialog" id='printToDocumentsModal'>
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Documentos a imprimir</h5>
                                <button type="button" className="close" onClick={this.closeConfirm} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div style={{ height: '75vh' }}>
                                {isMobile ? 
                                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '16px', padding: '20px' }}>
                                        {isGeneratingPDF ? 
                                        <div className="text-center">
                                            <div className="spinner-border text-primary" role="status" />
                                            <p className="mt-2">Generando PDF...</p>
                                        </div>
                                        : 
                                        <button className="btn btn-primary btn-lg" onClick={this.downloadPDF} disabled={!pdfBlobUrl}>
                                            <i className="fa fa-download mr-2"></i> Descargar PDF
                                        </button>}
                                    </div>
                                :
                                <PDFViewer style={{ height: '100%', width: '100%' }}>
                                    <DocumentsToPrint data={data} view={view} _user={_user} format={format} />
                                </PDFViewer>
                            }
                            </div>
                            {(view === 'creditNote' || view === 'invoice') && (
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={this.closeConfirm}>Cerrar</button>
                                    <button type="button" className="btn btn-primary" onClick={this.openSendMailModal} disabled={isGeneratingPDF} >
                                        <i className="fa fa-envelope mr-2"></i> Enviar por Correo
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <SendMailPDF MailTools={mailTools} SendEmail={this.sendEmailWithPDF} ShowExtraActions={true} type={view} isLoading={isGeneratingPDF} />
            </>
        );
    }
}


const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer,
        renderReducer: store.RenderReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setPrintToDocumentsModal: value => dispatch({ type: DISPATCH_ID.RENDER_PRINT_TO_DOCUMENTS_MODAL, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PrintToDocumentsModal);